import { useMatch } from "@tanstack/react-router"
import { memo } from "react"

import { AssetDetailsViewer } from "../../components/AssetDetailsViewer/AssetDetailsViewer"
import { IssueDetailsViewer } from "../../components/IssueDetailsViewer/IssueDetailsViewer"
import { MapVisibilityControl } from "../../components/MapVisibilityControl/MapVisibilityControl"

export const MapViewRightSlideOutContent = memo(() => {
	const match = useMatch({
		from: "/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/",
		shouldThrow: false,
	})

	const activeIssueId = match?.search?.issue ?? null

	const activeAssetId = match?.search?.asset ?? null

	if (activeIssueId) {
		return <IssueDetailsViewer issueId={activeIssueId} key={activeIssueId} />
	}

	if (activeAssetId) {
		return <AssetDetailsViewer assetId={activeAssetId} key={activeAssetId} />
	}

	return <MapVisibilityControl />
})
MapViewRightSlideOutContent.displayName = "MapViewRightSlideOutContent"
